import axios from "axios";
import { cacheAdapterEnhancer } from "axios-extensions";
export var cachedAxios = axios.create({
    headers: { "Cache-Control": "no-cache" },
    adapter: cacheAdapterEnhancer(axios.defaults.adapter),
});
//# sourceMappingURL=axiosClient.js.map